export class AdminSubscriptionCompanyConfiguration {
  restaurantServiceType: string

  deliveryFulfillmentType: string

  isDeliveryEnabled: boolean

  isPickupEnabled: boolean

  isDeliveryOrderNotificationEnabled: boolean

  isFreeShippingEnabled: boolean

  freeShippingMinimumOrderValue: number

  isFixedShippingFeeEnabled: boolean

  fixedShippingFeeValue: number

  localServiceRadiusMeters: number

  isVacationEnabled: boolean

  vacationStartDate?: string

  vacationEndDate?: string

  publicMenuCardLayout: string

  publicMenuCompactCategories: boolean

  publicMenuUseGradientHeader: boolean

  publicMenuHighlightPromotions: boolean

  publicMenuShowAwardsTab: boolean

  publicMenuShowPromotionsTab: boolean

  publicMenuShowExtraServicesTab: boolean

  constructor(data: Partial<AdminSubscriptionCompanyConfiguration> = {}) {
    this.restaurantServiceType = data.restaurantServiceType ?? ""

    this.deliveryFulfillmentType = data.deliveryFulfillmentType ?? ""

    this.isDeliveryEnabled = data.isDeliveryEnabled ?? false

    this.isPickupEnabled = data.isPickupEnabled ?? false

    this.isDeliveryOrderNotificationEnabled = data.isDeliveryOrderNotificationEnabled ?? false

    this.isFreeShippingEnabled = data.isFreeShippingEnabled ?? false

    this.freeShippingMinimumOrderValue = data.freeShippingMinimumOrderValue ?? 0

    this.isFixedShippingFeeEnabled = data.isFixedShippingFeeEnabled ?? false

    this.fixedShippingFeeValue = data.fixedShippingFeeValue ?? 0

    this.localServiceRadiusMeters = data.localServiceRadiusMeters ?? 0

    this.isVacationEnabled = data.isVacationEnabled ?? false

    this.vacationStartDate = data.vacationStartDate

    this.vacationEndDate = data.vacationEndDate

    this.publicMenuCardLayout = data.publicMenuCardLayout ?? ""

    this.publicMenuCompactCategories = data.publicMenuCompactCategories ?? false

    this.publicMenuUseGradientHeader = data.publicMenuUseGradientHeader ?? false

    this.publicMenuHighlightPromotions = data.publicMenuHighlightPromotions ?? false

    this.publicMenuShowAwardsTab = data.publicMenuShowAwardsTab ?? false

    this.publicMenuShowPromotionsTab = data.publicMenuShowPromotionsTab ?? false

    this.publicMenuShowExtraServicesTab = data.publicMenuShowExtraServicesTab ?? false
  }
}
